import { render, staticRenderFns } from "./PortalCareHistoryStep.vue?vue&type=template&id=3b598f1b&scoped=true"
import script from "./PortalCareHistoryStep.vue?vue&type=script&lang=js"
export * from "./PortalCareHistoryStep.vue?vue&type=script&lang=js"
import style0 from "./PortalCareHistoryStep.vue?vue&type=style&index=0&id=3b598f1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b598f1b",
  null
  
)

export default component.exports